export class ConfigMenuNames {
    static SEND_TO_SCUD = 'send_to_skud'
    static GIVE_PASS = 'give_pass'
    static GIVE_PASS_PERIOD = 'give_pass_period'
}
